export default "__VITE_ASSET__d3fdc375__"